import { loadImage } from './spriteLoader';
import { BackgroundLayer } from './BackgroundLayer';
import { AnimatedSprite } from './AnimatedSprite';

export async function loadBackground() {
  // Try to load images, fallback to colors if not available
  const [sky, mountains, trees] = await Promise.all([
    loadImage('/sprites/background/sky.png').catch(() => null),
    loadImage('/sprites/background/mountains.png').catch(() => null),
    loadImage('/sprites/background/trees.png').catch(() => null)
  ]);

  return [
    new BackgroundLayer(sky, 0.2, '#87CEEB'),
    new BackgroundLayer(mountains, 0.5, '#8B7355'),
    new BackgroundLayer(trees, 1.2, '#228B22')
  ];
}

export async function loadObstacleSprites() {
  // Try to load obstacle sprites, fallback to null if not available
  const [tree, cloud, lightning, wall] = await Promise.all([
    loadImage('/sprites/obstacles/tree.png').catch(() => null),
    loadImage('/sprites/obstacles/cloud.png').catch(() => null),
    loadImage('/sprites/obstacles/lightning.png').catch(() => null),
    loadImage('/sprites/obstacles/wall.png').catch(() => null)
  ]);

  return {
    TREE: tree ? new AnimatedSprite({
      image: tree,
      frameWidth: 64,
      frameHeight: 128,
      frameCount: 1,
      frameSpeed: 1
    }) : null,
    CLOUD: cloud ? new AnimatedSprite({
      image: cloud,
      frameWidth: 96,
      frameHeight: 64,
      frameCount: 2,
      frameSpeed: 20
    }) : null,
    LIGHTNING: lightning ? new AnimatedSprite({
      image: lightning,
      frameWidth: 64,
      frameHeight: 128,
      frameCount: 4,
      frameSpeed: 6
    }) : null,
    WALL: wall ? new AnimatedSprite({
      image: wall,
      frameWidth: 60,
      frameHeight: 80,
      frameCount: 1,
      frameSpeed: 1
    }) : null
  };
}

export async function loadDragonSprite() {
  return loadImage('/sprites/dragon.png').catch(() => null);
}

